import { isEmpty } from '../baseUtils';
import { decodeCookie } from './auth';

const isSsr = (): boolean => typeof window === 'undefined';
export const getCookieCustno = async () => {
  let custno = '';
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    custno = cookie.get('custno')?.value as string;
  } else {
    const { getCookie } = await import('cookies-next');
    custno = getCookie('custno') as string;
  }
  if (isEmpty(custno)) {
    custno = '';
  }
  return custno;
};

// TrackingIssueNo 정보 조회.

export const getCookieTrackingIssueNo = async () => {
  let trackingIssueNo = '0';
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    trackingIssueNo = cookie.get('trackingIssueNo')?.value as string;
  } else {
    const { getCookie } = await import('cookies-next');
    trackingIssueNo = getCookie('trackingIssueNo') as string;
  }
  if (isEmpty(trackingIssueNo)) {
    trackingIssueNo = '0';
  }
  return trackingIssueNo;
};

export const getCookieAdfrom = async () => {
  let adfrom = '';
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    adfrom = cookie.get('adfrom')?.value as string;
  } else {
    const { getCookie } = await import('cookies-next');
    adfrom = getCookie('adfrom') as string;
  }
  if (isEmpty(adfrom)) {
    adfrom = '';
  }
  return adfrom;
};

// PC모드 세팅.

export const getCookieBasketCount = async () => {
  let BasketCnt = '0';
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    BasketCnt = cookie.get('BasketCnt')?.value as string;
  } else {
    const { getCookie } = await import('cookies-next');
    BasketCnt = getCookie('BasketCnt') as string;
  }
  if (isEmpty(BasketCnt)) {
    BasketCnt = '0';
  }
  return BasketCnt;
};

// WckWMarketingValue(Women) 정보 조회.

export const getCookieWckWMarketingValue = async () => {
  let wckWMarketingValue = '0';
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    wckWMarketingValue = cookie.get('wckWMarketingValue')?.value as string;
  } else {
    const { getCookie } = await import('cookies-next');
    wckWMarketingValue = getCookie('wckWMarketingValue') as string;
  }
  if (isEmpty(wckWMarketingValue)) {
    wckWMarketingValue = '0';
  }
  return wckWMarketingValue;
};

// WckMMarketingValue(Men) 정보 조회.

export const getCookieWckMMarketingValue = async () => {
  let wckMMarketingValue = '0';
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    wckMMarketingValue = cookie.get('wckMMarketingValue')?.value as string;
  } else {
    const { getCookie } = await import('cookies-next');
    wckMMarketingValue = getCookie('wckMMarketingValue') as string;
  }
  if (isEmpty(wckMMarketingValue)) {
    wckMMarketingValue = '0';
  }
  return wckMMarketingValue;
};

export const getCookieWckGenderValue = async (isDesktop?: boolean) => {
  let wckGenderValue = 'All';
  // 데스크탑이고 isDesktop 속성이 있으면 데스크탑 페이지 개발여부
  if (typeof isDesktop === 'boolean' && isDesktop) {
    return 'All';
  }
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    wckGenderValue = cookie.get('wckGenderValue')?.value as string;
  } else {
    const { getCookie } = await import('cookies-next');
    wckGenderValue = getCookie('wckGenderValue') as string;
  }

  // 모바일이고 isDesktop 속성 없으면 데스크탑 페이지 개발여부
  if (isEmpty(wckGenderValue)) {
    wckGenderValue = 'Women';
  }
  return wckGenderValue as 'Women' | 'Men' | 'All';
};

// AS-IS 도메인 정보 조회.

export const getCookieWckDisplayFrontLocation = async () => {
  let wckDisplayFrontLocation = '';
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    wckDisplayFrontLocation = cookie.get('wckDisplayFrontLocation')
      ?.value as string;
  } else {
    const { getCookie } = await import('cookies-next');
    wckDisplayFrontLocation = getCookie('wckDisplayFrontLocation') as string;
  }
  return wckDisplayFrontLocation;
};

// 최근 본 상품코드 쿠키 정보 조회.

export const getCookieWckRP = async () => {
  let wckRP: string[] = [];
  let cookieValue = '';
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    cookieValue = cookie.get('wckRP')?.value as string;
  } else {
    const { getCookie } = await import('cookies-next');
    cookieValue = getCookie('wckRP') as string;
  }

  if (!isEmpty(cookieValue)) {
    wckRP = String(cookieValue).split(',');
  }
  return wckRP;
};

export const getWckDisplaySID = async () => {
  let wckDisplaySID = '';
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    wckDisplaySID = cookie.get('wckDisplaySID')?.value as string;
  } else {
    const { getCookie } = await import('cookies-next');
    wckDisplaySID = getCookie('wckDisplaySID') as string;
  }
  return decodeCookie(wckDisplaySID, 'wckDisplaySID')
    ? decodeCookie(wckDisplaySID, 'wckDisplaySID')
    : '';
};

// 최근 검색어 저장. 추후 삭제

export const getCookieWckGenderValueForMainPage = async () => {
  let wckGenderValue = '';
  if (isSsr()) {
    const { cookies } = await import('next/headers');
    const cookie = await cookies();
    wckGenderValue = cookie.get('wckGenderValue')?.value as string;
  } else {
    const { getCookie } = await import('cookies-next');
    wckGenderValue = getCookie('wckGenderValue') as string;
  }
  return wckGenderValue;
};
